import React from 'react';
import ReactTooltip from 'react-tooltip';

class DialogButton extends React.PureComponent {
    render() {
        return (
            <React.Fragment>
                <a
                    className={this.props.buttonClass}
                    data-tip={this.props.customContentHTML}
                    data-event="click focus"
                >
                    ?
                </a>
                <ReactTooltip globalEventOff="click" type="light" effect="solid" border html />
            </React.Fragment>
        );
    }
}

export default DialogButton;  